export default {
  tiles: [
    {
      title: 'Tim Chen',
      titleSize: '3',
      description: 'Board Member',
      descriptionSize: '1',
      subheader: 'CEO and Co-Founder of NerdWallet',
      subheaderLink: 'https://www.linkedin.com/in/tim-chen-1722b9/',
      boardDescription:
        'Tim is CEO of NerdWallet and co-founded the personal finance company in 2009. Tim sets the strategic vision for NerdWallet and is determined to give consumers clarity around all of life’s financial decisions. He currently sits on the board of the National Foundation for Credit Counseling (NFCC).',
      boardBackground:
        'Before founding NerdWallet, Tim was a hedge fund analyst at Perry Capital investing in payment processing firms, credit card networks and technology companies. He also worked as an equity analyst at Credit Suisse First Boston.',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Tom Loverro',
      titleSize: '3',
      description: 'Board Member',
      descriptionSize: '1',
      subheader: 'General Partner at IVP',
      subheaderLink: 'https://www.linkedin.com/in/tomloverro/',
      boardDescription:
        'Tom joined IVP in April 2015 focusing on investing in later-stage, high growth consumer and enterprise companies. He currently serves as a Board Director or Observer for Attentive, Coinbase, HashiCorp, NerdWallet, and Podium.',
      boardBackground:
        'Tom was actively involved in sourcing, executing and managing investments in Amplitude, CircleCI, Datadog (DDOG), GitHub (MSFT), IEX, OneDeck (ONDK), and Tanium. He has been recognized as one of venture capital’s up-and-comers by Forbes Magazine.',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Simon Williams',
      titleSize: '3',
      description: 'Board Member',
      descriptionSize: '1',
      subheader: 'CEO and Chairman of Camelot Financial Capital',
      subheaderLink: 'https://www.linkedin.com/in/simon-williams-22108862/',
      boardDescription:
        'Simon is CEO of Camelot Financial Capital, chairman of Crowdcube and Trussle and serves on the board of NerdWallet. He provides strategic and operational support to financial services businesses that have a competitive edge in delivering superior service, including OnDeck Capital (ONDK), Blingnation (Lifelock Inc.) and 3Bl/Justmeans.',
      boardBackground:
        'Prior to Camelot Financial, Simon spent 9 years at Citi (C), heading up its international retail bank, consumer groups for Asia Pacific and Latin America and serving as chief risk officer for Citigroup Global consumer group. More recently, he served as head of HSBC’s Wealth management group from 2011-2014.',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'James D. Robinson III',
      titleSize: '3',
      description: 'Board Member',
      descriptionSize: '1',
      subheader: 'General Partner and Co-Founder of RRE Ventures',
      subheaderLink:
        'https://www.linkedin.com/in/james-d-robinson-111-10862523/',
      boardDescription:
        'James is a general partner and co-founder of RRE Ventures, focusing on emerging enterprise technology with a special concentration in financial services technology. He has extensive leadership experience and currently serves on the Boards of AvantCredit, Coverhound and NerdWallet.',
      boardBackground:
        'Prior to RRE, James was the CEO and Chairman of American Express (AXP). He also served as a longtime Board member for The Coca-Cola Company (KO) and was a chairperson of Bristol Myers Squibb (BMY).',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Jennifer Ceran',
      titleSize: '3',
      description: 'Board Member',
      descriptionSize: '1',
      subheader: 'CFO at Smartsheet',
      subheaderLink: 'https://www.linkedin.com/in/jenniferceran',
      boardDescription:
        'Jennifer has been CFO of Smartsheet Inc. (SMAR) since September 2016 and currently serves on the board of Auth0, True Search and NerdWallet.',
      boardBackground:
        'She is a seasoned financial executive with over 30 years of experience working across consumer products, technology and finance at companies such as eBay/PayPal, Cisco, Box and Sara Lee Corporation.',
      columnClass: 'matrix-2-col__tile',
    },
    {
      title: 'Lynne Laube',
      titleSize: '3',
      description: 'Board Member',
      descriptionSize: '1',
      subheader: 'CEO and Co-founder of Cardlytics',
      subheaderLink: 'https://www.linkedin.com/in/lynne-laube-68430b1',
      boardDescription:
        'Lynne co-founded Cardlytics in 2008, which she took public in 2018. The company has been recognized as one of the fastest-growing tech companies by Deloitte Fast 500 and Inc. 5000 multiple years in a row.',
      boardBackground:
        'She has more than 25 years of experience helping marketers at Fortune 500 companies and financial institutions around the world – helping them become better and more meaningful partners. Laube has rolled out numerous partnerships with the largest banks in the US including Bank of America, Wells Fargo and Chase. She has been named one of the top 10 venture-backed female founders and featured in Inc. Magazine’s Inspiring Women to Watch.',
      columnClass: 'matrix-2-col__tile',
    },
  ],
};
